import { useState } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, TextField, Autocomplete, Alert, CircularProgress } from '@mui/material'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { createPickingList } from '../../api/logistica'
import { listOrders } from '../../api/comenzi'
import { errorMessage } from '../../api/client'

export default function CreatePickingListDialog({ open, onClose, onCreated }: { open: boolean; onClose: () => void; onCreated: (id: string) => void }) {
  const qc = useQueryClient()
  const [orderId, setOrderId] = useState<string | null>(null)
  const { data: orders } = useQuery({ queryKey: ['comercial', 'comenzi'], queryFn: listOrders, enabled: open })
  const eligible = orders?.filter((o) => o.status === 'Confirmed' || o.status === 'PartiallyDelivered') ?? []

  const mutation = useMutation({
    mutationFn: () => createPickingList(orderId!),
    onSuccess: ({ id }) => {
      void qc.invalidateQueries({ queryKey: ['logistica', 'picking'] })
      setOrderId(null)
      onCreated(id)
    },
  })

  const handleClose = () => { setOrderId(null); mutation.reset(); onClose() }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Listă de picking din comandă</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 0.5 }}>
          <Autocomplete
            options={eligible.map((o) => o.id)}
            getOptionLabel={(id) => { const o = eligible.find((x) => x.id === id); return o ? `${o.orderNumber} — ${o.clientName}` : id }}
            value={orderId} onChange={(_, v) => setOrderId(v)}
            renderInput={(params) => <TextField {...params} label="Comandă confirmată, cu rest de livrat" />}
          />
          {mutation.isError && <Alert severity="error">{errorMessage(mutation.error)}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={handleClose}>Renunță</Button>
        <Button variant="contained" disabled={!orderId || mutation.isPending} onClick={() => mutation.mutate()}
          startIcon={mutation.isPending ? <CircularProgress size={16} color="inherit" /> : undefined}>
          Generează
        </Button>
      </DialogActions>
    </Dialog>
  )
}
